'use client'
import React, { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import { Button } from "../ButtonElement";
import { Theme } from "../WebsiteThemeElements";
import { animateScroll as scroll } from 'react-scroll'
import illustration from "../../images/swərl_illustration_logo.png"
import {
  InfoContainer,
  InfoWrapper,
  Column1,
  Column2,
  InfoRow,
  ImgWrap,
  Img,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
} from "../InfoSection/InfoElements";
import { Form, FormWrapper } from "../CustomForm/CustomFormElements";
import { ArrowForward, ArrowRight, ContentBtnWrapper, ContentH1, ContentP, ContentWrapper } from "./WelcomPageElements";

const WelcomePage = ({
  lightBg,
  id,
  imgStart,
  topLine,
  headLine,
  description,
  buttonLabel,
  lightText,
  darkText,
  img,
  alt,
  primary,
  dark,
  dark2,
  isCircular,
  to,
}) => {
    const [hover, setHover] = useState(false)
    const onHover = () => {
        setHover(!hover)
    }
useEffect(() => {
  return
  
}, [])

const toggleHome = () => {
  scroll.scrollToTop();
}

  return (
    <>
    
     
        <ContentWrapper lightBg={lightBg} id={id}>
          <InfoWrapper>
            
            <InfoRow right imgStart={imgStart}>
            
              <Column1>
                <TextWrapper>
                  <FormWrapper style={{backgroundColor: 'transparent', border: "none"}}>

                    <TopLine style={{ marginBottom: '0%', fontSize: '30px'}}>Web Monetization Rebuilt</TopLine>
                    <ContentP style={{ fontSize: '15px'}}>Powering the Creator Economy.</ContentP>
                    <ContentP style={{ fontSize: '18px'}}>Welcome to Swərl, a next-generation Web Monetization service created by the Sonar Muse team. Built on the XRP Ledger (XRPL), Swərl is designed to fundamentally shift how digital content is valued, enjoyed, and monetized across the internet.</ContentP>

                <ContentBtnWrapper>
                    <Button to='/signup'
                        primary='true'
                        dark='true'
                        onMouseEnter={onHover}
                        onMouseLeave={onHover}
                        smooth={true}
                        exact='true' 
                        >
                        Access Platform. {hover ? <ArrowForward /> : <ArrowRight />}
                    </Button>
                   
                </ContentBtnWrapper>
                <br/>
                <Button to='/about'
                        primary='false'
                        dark='false'
                        smooth={true}
                        exact='true' 
                        style={{backgroundColor:"transparent"}}
                        >
                        Learn About Us
                    </Button>
                </FormWrapper>
                </TextWrapper>

              </Column1>
              
              
              <Column2>
         
                <ImgWrap>
                  <Img onContextMenu={(e) =>  {e.preventDefault()}} src={illustration} alt={alt} isCircular={isCircular} style={{
                    width: "30rem"
                  }} />
                </ImgWrap>
              
              </Column2> 
              
            </InfoRow>
          </InfoWrapper>
        </ContentWrapper>
    </>
  );
};

export default WelcomePage;
